package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.EditServiceSectionData
import com.essntl.features.service.ui.components.richtext.ServiceRichTextEditor
import com.essntl.uikit.components.utils.spacing
import com.mohamedrejeb.richeditor.model.RichTextState

@Composable
internal fun DescriptionSectionItem(
    richTextState: RichTextState,
    enabled: Boolean,
    onRewriteWithAI: (String) -> Unit,
) {
    Spacer(modifier = Modifier.height(5.spacing))

    ServiceRichTextEditor(
        richTextState = richTextState,
        enabled = enabled, // && !isLoading, TODO
        modifier =
            Modifier
                .fillMaxWidth(),
        aiEnabled = true,
        onRewriteWithAI = {
            onRewriteWithAI(
                richTextState.annotatedString.toString(),
            )
        },
    )
}
